import { JourneyType } from '@bytel/leviator';

import { FaiType } from '@app-types/plan';
import { SimulatedCart } from '@app-types/simulator/virtual-cart';

import { formatTagText, sendTracking } from '@helpers/tracking';

import { PlanRange } from '@constants/plan';

export function sendPromoSimulatorPageTracking() {
    sendTracking(false, {
        page: 'Home_box_forfait',
        pageCategory: 'Page_offres_box_forfait',
        universe: 'Boutique_web',
    });
}

export function sendResetFilterTracking(wording: string, simulatedCart: SimulatedCart, faiPlan?: FaiType) {
    const commercialRange = faiPlan?.commercialRange ?? PlanRange.DEFAULT;
    sendTracking(false, {
        action: 'Clic_selection',
        category: 'Selection_produits_Toutatis',
        name: formatTagText(wording),
        variables: {
            ForfaitMobile: formatTagText(
                simulatedCart.quotes
                    .reduce((acc: string[], quote): string[] => {
                        if (quote.type === JourneyType.MOBILE_ACQUISITION) {
                            acc.push(quote.products[0]!.name);
                        }
                        return acc;
                    }, [])
                    .join('_'),
            ),
            TypeBox: formatTagText(commercialRange.charAt(0).toUpperCase() + commercialRange.slice(1)),
        },
    });
}
